function analyysityokalu_draw_chart(element, data){
    var datasets = [];
    for (var i = 0; i < data['datasets'].length; i++){
        var numbers = data['datasets'][i]['data'];
        numbers = numbers.map(function(item){
            return Math.round(item);
        });
        datasets.push({
            "label": data['datasets'][i]['label'],
            "data": numbers,
            "fill": false,
            "borderColor": data['datasets'][i]['color'],
            "backgroundColor": data['datasets'][i]['color'],
            "lineTension": 0.1
        });
    }
    var chartData = {
        "type":"line",
        "data":{
            "labels": data['labels'],
            "datasets": datasets
        },
        "options":{
            plugins: {
                datalabels: {
                display: false
                }
            },
            title: {
                display: true,
                'fontSize': 17,
                text: data['title']
            },
            'legend': {
                'display': true,
                'position': 'bottom',
                'labels':{
                    'boxWidth': 20
                }
            }
        }
    };
    new Chart(element, chartData);
}

function analyysityokalu_charts(data){
    var chartsContainer = jQuery(chartsContainerID);
    if(chartsContainer.length){
        var supertitle = '';
        for(key in data){
            if(data[key]['supertitle'] != supertitle){
                supertitle = data[key]['supertitle'];
                if(supertitle){
                    jQuery(chartsContainer).append('<h4>'+supertitle+'</h4>');
                }
            }
            var container = jQuery('<canvas width="undefined" height="undefined"></canvas>');
            jQuery(chartsContainer).append(container);
            analyysityokalu_draw_chart(jQuery(container)[0], data[key]);
        }
    }
}